(function () {
  'use strict';

  if (window.VSCRO) return;

  var allowedEvents = new Set([
    'ad_landing_view',
    'search_submit',
    'search_zero',
    'search_result_click',
    'filter_apply',
    'product_view',
    'add_to_cart',
    'witek_impression',
    'witek_open',
    'witek_dismiss',
    'recommendation_view',
    'recommendation_click',
    'recommended_product_add',
    'recommendation_no_match',
    'bundle_start',
    'bundle_progress',
    'bundle_abandon',
    'bundle_complete',
    'bundle_discount_confirmed',
    'return_to_single_purchase',
    'inventory_conflict',
    'sold_out_recovery_view',
    'zero_results_recovery',
    'view_cart',
    'begin_checkout',
    'purchase',
    'cancel',
    'refund',
    'ui_error'
  ]);

  var blockedKeys = new Set([
    'address',
    'customer',
    'device_type',
    'email',
    'event',
    'event_id',
    'event_time',
    'first_name',
    'last_name',
    'message',
    'name',
    'phone',
    'query',
    'template_version',
    'vs_origin'
  ]);

  var blockedKeyParts = new Set([
    'address',
    'customer',
    'email',
    'firstname',
    'first_name',
    'fullname',
    'full_name',
    'lastname',
    'last_name',
    'message',
    'phone',
    'telephone'
  ]);

  var seen = new Set();
  var qaEvents = [];
  var previousFilterParams = new URLSearchParams(window.location.search);
  var debugEnabled = new URLSearchParams(window.location.search).get('vs_cro_debug') === '1';
  var lastCustomFilterSignature = '';
  var privacyLoadRequested = false;
  var recoveryTargets = new Set();
  var recoveryObserver;
  var recoveryFallbackBound = false;

  function inspectRecovery(element) {
    if (!element.isConnected) {
      recoveryTargets.delete(element);
      if (recoveryObserver) recoveryObserver.unobserve(element);
      return;
    }
    if (!processingAllowed('sold_out_recovery_view') || document.visibilityState === 'hidden' ||
        element.hidden || element.closest('[hidden]') || !element.getClientRects().length) return;
    var style = window.getComputedStyle(element);
    if (style.visibility === 'hidden' || style.display === 'none' || Number(style.opacity) === 0) return;
    var rect = element.getBoundingClientRect();
    var width = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
    var height = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
    if (!rect.width || !rect.height || (width * height) / (rect.width * rect.height) < 0.25) return;
    if (track('sold_out_recovery_view', {
      source: 'pdp',
      recovery_type: element.querySelector('a[href^="#VSSoldRecovery-"]') ? 'similar_available' : 'choose_available_variant'
    }, { onceKey: 'sold_out_recovery_view:' + window.location.pathname })) {
      recoveryTargets.delete(element);
      if (recoveryObserver) recoveryObserver.unobserve(element);
    }
  }

  function observeRecovery(element) {
    if (!element || !processingAllowed('sold_out_recovery_view') ||
        seen.has('sold_out_recovery_view:' + window.location.pathname)) return;
    if (!recoveryTargets.has(element)) {
      recoveryTargets.add(element);
      if (typeof window.IntersectionObserver === 'function') {
        if (!recoveryObserver) recoveryObserver = new window.IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.25) inspectRecovery(entry.target);
          });
        }, { threshold: 0.25 });
        recoveryObserver.observe(element);
      } else if (!recoveryFallbackBound) {
        recoveryFallbackBound = true;
        var scheduled = false;
        var check = function () {
          if (scheduled || !recoveryTargets.size) return;
          scheduled = true;
          window.requestAnimationFrame(function () {
            scheduled = false;
            recoveryTargets.forEach(inspectRecovery);
          });
        };
        window.addEventListener('scroll', check, { passive: true, capture: true });
        window.addEventListener('resize', check, { passive: true });
      }
    }
    // Recheck the current viewport on consent changes, never replay past views.
    inspectRecovery(element);
  }

  function processingAllowed(name) {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try {
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' ||
          privacy.analyticsProcessingAllowed() !== true) return false;
      // Campaign attribution needs marketing permission as well as analytics.
      return name !== 'ad_landing_view' ||
        (typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed() === true);
    } catch (error) {
      return false;
    }
  }

  function onPrivacyReady() {
    if (!processingAllowed('product_view')) {
      qaEvents.length = 0;
      return;
    }
    if (document.readyState !== 'loading') initPageEvents();
  }

  function loadPrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      onPrivacyReady();
      return;
    }
    if (privacyLoadRequested || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    privacyLoadRequested = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) onPrivacyReady();
      });
    } catch (error) {
      // No retry loop, queue, cookie fallback, or implicit permission.
    }
  }

  function deviceType() {
    if (window.matchMedia('(max-width: 749px)').matches) return 'mobile';
    if (window.matchMedia('(max-width: 989px)').matches) return 'tablet';
    return 'desktop';
  }

  function cleanKey(key) {
    return String(key || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9_]/g, '_')
      .replace(/_+/g, '_')
      .slice(0, 60);
  }

  function cleanValue(value) {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;
    if (typeof value === 'string') return value.trim().slice(0, 120);
    return undefined;
  }

  function isBlockedKey(key) {
    if (blockedKeys.has(key)) return true;
    var compact = key.replace(/_/g, '');
    return Array.from(blockedKeyParts).some(function (part) {
      return key.split('_').includes(part) || compact.includes(part.replace(/_/g, ''));
    });
  }

  function sanitize(params) {
    var output = {};

    Object.entries(params || {}).forEach(function (entry) {
      var key = cleanKey(entry[0]);
      if (!key || isBlockedKey(key)) return;

      var value = cleanValue(entry[1]);
      if (value === undefined || value === '') return;
      output[key] = value;
    });

    return output;
  }

  function track(name, params, options) {
    if (!allowedEvents.has(name)) return false;
    if (!processingAllowed(name)) return false;

    var settings = options || {};
    var onceKey = settings.onceKey ? String(settings.onceKey) : '';
    if (onceKey && seen.has(onceKey)) return false;
    if (onceKey) seen.add(onceKey);

    var payload = Object.assign(
      {
        event: name,
        event_id:
          window.crypto && typeof window.crypto.randomUUID === 'function'
            ? window.crypto.randomUUID()
            : String(Date.now()) + '-' + Math.random().toString(16).slice(2),
        event_time: new Date().toISOString(),
        template_version: 'cro-2026-09-07-events-v5',
        device_type: deviceType(),
        vs_origin: 'theme'
      },
      sanitize(params)
    );

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    qaEvents.push(payload);
    if (qaEvents.length > 100) qaEvents.shift();

    if (debugEnabled && window.console && typeof window.console.info === 'function') {
      window.console.info('[VSCRO]', JSON.stringify(payload));
    }

    document.dispatchEvent(new CustomEvent('vs:analytics', { detail: payload }));
    return true;
  }

  function queryShape(value) {
    var query = String(value || '').trim();
    return {
      query_length: query.length,
      query_word_count: query ? query.split(/\s+/).length : 0,
      query_has_number: /\d/.test(query)
    };
  }

  function listContext(element) {
    if (!(element instanceof Element)) {
      if (document.querySelector('[data-vs-cro-product]')) return 'pdp';
      if (document.querySelector('[data-vs-cro-cart]')) return 'cart';
      if (document.querySelector('.collection, #product-grid')) return 'collection';
      if (window.location.pathname === '/') return 'home';
      return 'unknown';
    }
    if (element.closest('[data-vs-cro-product]')) return 'pdp';
    if (element.closest('[data-vsc-form], [data-vs-cro-cart]')) return 'cart';
    if (element.closest('predictive-search-component')) return 'predictive_search';
    if (element.closest('[data-collection], .collection, #product-grid')) return 'collection';
    if (window.location.pathname === '/') return 'home';
    return 'unknown';
  }

  function activeFilterEntries(params) {
    return Array.from(params.entries()).filter(function (entry) {
      return entry[0].indexOf('filter.') === 0 && String(entry[1] || '').trim() !== '';
    });
  }

  function activeFilterSignature(params) {
    return activeFilterEntries(params)
      .map(function (entry) { return entry[0] + '\u0000' + entry[1]; })
      .sort()
      .join('\u0001');
  }

  function changedFilterKey(beforeParams, afterParams) {
    var before = activeFilterEntries(beforeParams).map(function (entry) {
      return entry[0] + '\u0000' + entry[1];
    });
    var after = activeFilterEntries(afterParams).map(function (entry) {
      return entry[0] + '\u0000' + entry[1];
    });
    var changedEntry = after.find(function (entry) { return !before.includes(entry); }) ||
      before.find(function (entry) { return !after.includes(entry); });
    return changedEntry ? changedEntry.split('\u0000')[0] : 'multiple';
  }

  function trackCustomFilterForm(form) {
    var submittedParams = new URLSearchParams(new FormData(form));
    var signature = submittedParams.toString();
    if (signature === lastCustomFilterSignature) return;
    lastCustomFilterSignature = signature;

    var submittedFilters = activeFilterEntries(submittedParams);
    var currentFilters = activeFilterEntries(previousFilterParams);
    var submittedChange = changedFilterKey(previousFilterParams, submittedParams);

    track('filter_apply', {
      filter_key: submittedChange,
      filter_action: submittedFilters.length >= currentFilters.length ? 'add_or_change' : 'remove',
      active_filter_count: submittedFilters.length,
      source: 'collection_filters'
    });

    previousFilterParams = new URLSearchParams(submittedParams.toString());
  }

  function initPageEvents() {
    var product = document.querySelector('[data-vs-cro-product]');
    if (product) {
      track(
        'product_view',
        {
          product_id: product.dataset.productId,
          variant_id: product.dataset.variantId,
          availability: product.dataset.available === 'true',
          list_context: document.referrer ? 'referral' : 'direct'
        },
        { onceKey: 'product_view:' + window.location.pathname }
      );
    }

    var cart = document.querySelector('[data-vs-cro-cart]');
    if (cart) {
      track(
        'view_cart',
        {
          cart_item_count: Number(cart.dataset.cartCount || 0),
          bundle_stage: Number(cart.dataset.bundleStage || 0),
          discount_confirmed: cart.dataset.discountConfirmed === 'true'
        },
        { onceKey: 'view_cart:' + window.location.pathname }
      );
    }

    observeRecovery(document.querySelector('.vsp-sold-rescue'));

    var url = new URL(window.location.href);
    var creativeId = url.searchParams.get('creative_id') || url.searchParams.get('utm_content');
    if (creativeId) {
      track(
        'ad_landing_view',
        {
          source: url.searchParams.get('utm_source') || 'unknown',
          campaign: url.searchParams.get('utm_campaign') || 'unknown',
          creative_id: creativeId
        },
        { onceKey: 'ad_landing_view:' + window.location.pathname }
      );
    }
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      if (form.matches('.predictive-search-form, form[action*="/search"]')) {
        var input = form.querySelector('input[type="search"], input[name="q"]');
        track('search_submit', Object.assign({ source: 'search_form' }, queryShape(input && input.value)));
      }

      if (form.matches('.vsca__filters')) {
        trackCustomFilterForm(form);
      }

      if (form.matches('[data-vsc-form]')) {
        var submitter = event.submitter;
        if (!(submitter instanceof HTMLElement) || submitter.getAttribute('name') !== 'checkout') return;

        track('begin_checkout', {
          cart_item_count: Number(form.dataset.cartCount || 0),
          bundle_stage: Number(form.dataset.bundleStage || 0),
          discount_confirmed: form.dataset.discountConfirmed === 'true'
        });
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var resultLink = target.closest(
        'predictive-search-component .predictive-search-results__card a, predictive-search-component .vs-search-ai-card__link'
      );
      if (resultLink) {
        var card = resultLink.closest('.predictive-search-results__card');
        var cards = Array.from(
          resultLink.closest('predictive-search-component').querySelectorAll('.predictive-search-results__card')
        );

        track('search_result_click', {
          position: Math.max(1, cards.indexOf(card) + 1),
          availability: card && card.dataset.vsAvailability !== 'sold',
          result_type: 'product',
          list_context: 'predictive_search'
        });

        if (card && card.dataset.vsWitekRanked === 'true') {
          track('recommendation_click', {
            position: Math.max(1, cards.indexOf(card) + 1),
            availability: card.dataset.vsAvailability !== 'sold',
            source: 'predictive_search'
          });
        }
      }

      var zeroRecovery = target.closest('.vsca__empty [data-vsca-clear]');
      if (zeroRecovery) {
        track('zero_results_recovery', {
          source: 'collection',
          recovery_type: zeroRecovery.closest('.vsca__empty-chips') ? 'remove_one_filter' : 'clear_filters'
        });
      }
    },
    true
  );

  document.addEventListener('filter:update', function (event) {
    var params = event.detail && event.detail.queryParams;
    if (!(params instanceof URLSearchParams)) return;
    if (activeFilterSignature(params) === activeFilterSignature(previousFilterParams)) return;

    var before = activeFilterEntries(previousFilterParams);
    var after = activeFilterEntries(params);
    var changed = changedFilterKey(previousFilterParams, params);

    track('filter_apply', {
      filter_key: changed,
      filter_action: after.length >= before.length ? 'add_or_change' : 'remove',
      active_filter_count: after.length
    });

    previousFilterParams = new URLSearchParams(params.toString());
  });

  document.addEventListener('cart:update', function (event) {
    var data = event.detail && event.detail.data ? event.detail.data : {};
    if (data.didError) {
      track('ui_error', { component: 'cart', error_code: 'cart_update_failed', action: data.source || 'update' });
      return;
    }

    if (data.source === 'product-form-component') {
      track('add_to_cart', {
        product_id: data.productId,
        variant_id: data.variantId || event.detail.sourceId,
        item_count: Number(data.itemCount || 1),
        bundle_mode: false,
        list_context: listContext(event.target)
      });
    }
  });

  document.addEventListener('cart:error', function (event) {
    track('ui_error', {
      component: 'cart',
      error_code: 'cart_error',
      action: event.detail && event.detail.sourceId ? 'add_to_cart' : 'unknown'
    });
  });

  window.VSCRO = {
    track: track,
    queryShape: queryShape,
    listContext: listContext,
    getQAEvents: function () {
      return qaEvents.slice();
    }
  };

  // The API is authoritative: never infer consent from event.detail or cookies.
  document.addEventListener('visitorConsentCollected', onPrivacyReady);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'hidden') recoveryTargets.forEach(inspectRecovery);
  });
  loadPrivacy();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      loadPrivacy();
      initPageEvents();
    }, { once: true });
  } else {
    initPageEvents();
  }
})();
